export enum SafetyEventTypeOperator {
    And,
    Or,
}

export enum SafetyEventId {
    Identified,
    NotIdentified,
}

export enum SafetyEventType {
    AdverseEvent,
    NotAdverseEvent,
    ProductQualityComplaint,
    SpecialSituation,
    NotProductQualityComplaint,
    NotSpecialSituation,
}

export enum SafetyEventAck {
    Acknowledged,
    NotAcknowledged,
}

export type SafetyEvent = {
    identification: SafetyEventId | null;
    typeOperator: SafetyEventTypeOperator;
    types: SafetyEventType[];
    acknowledgments: SafetyEventAck[];
};

// Older saved filters omitted this field and were interpreted as And by the server.
export const resolveSafetyEventTypeOperator = (
    safetyEvent: SafetyEvent,
): SafetyEventTypeOperator =>
    safetyEvent.typeOperator ?? SafetyEventTypeOperator.And;

export const SafetyEventAsString = (safetyEvent: SafetyEvent): string => {
    const parts: string[] = [];

    if (safetyEvent.identification !== null) {
        parts.push(SEIdToString(safetyEvent.identification));
    }

    safetyEvent.types.forEach((type) => {
        parts.push(SETypeToString(type));
    });

    safetyEvent.acknowledgments.forEach((acknowledgment) => {
        parts.push(SEAckToString(acknowledgment));
    });

    return parts.join(", ");
};

export const SEIdToString = (safetyEvent: SafetyEventId): string => {
    switch (safetyEvent) {
        case SafetyEventId.Identified:
            return "Identified";
        case SafetyEventId.NotIdentified:
            return "Not Identified";
    }
};

export const SETypeToString = (safetyEvent: SafetyEventType): string => {
    switch (safetyEvent) {
        case SafetyEventType.AdverseEvent:
            return "Adverse Event";
        case SafetyEventType.NotAdverseEvent:
            return "Not Adverse Event";
        case SafetyEventType.ProductQualityComplaint:
            return "Product Quality Complaint";
        case SafetyEventType.SpecialSituation:
            return "Special Situation";
        case SafetyEventType.NotProductQualityComplaint:
            return "Not Product Quality Complaint";
        case SafetyEventType.NotSpecialSituation:
            return "Not Special Situation";
    }
};

export const SEAckToString = (safetyEvent: SafetyEventAck): string => {
    switch (safetyEvent) {
        case SafetyEventAck.Acknowledged:
            return "Acknowledged";
        case SafetyEventAck.NotAcknowledged:
            return "Not Acknowledged";
    }
};
